import { useState } from 'react';
import { Box, Button, MenuItem, TextField } from '@mui/material';
import { SECTION_ICONS } from './types';

export interface SectionFormValues {
  title: string;
  icon: string;
}

interface SectionFormProps {
  initial: SectionFormValues;
  submitLabel: string;
  onCancel: () => void;
  onSubmit: (values: SectionFormValues) => void;
}

const SectionForm = ({ initial, submitLabel, onCancel, onSubmit }: SectionFormProps) => {
  const [values, setValues] = useState(initial);
  const [touched, setTouched] = useState(false);
  const titleError = touched && !values.title.trim();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setTouched(true);
    if (!values.title.trim()) return;
    onSubmit({ ...values, title: values.title.trim() });
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.key === 'Escape' && onCancel()}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1.25,
        p: 1.5,
        borderRadius: 2,
        bgcolor: 'action.hover',
      }}
    >
      <Box sx={{ display: 'flex', gap: 1 }}>
        <TextField
          select
          size="small"
          label="Icon"
          value={values.icon}
          onChange={(e) => setValues({ ...values, icon: e.target.value })}
          sx={{ width: 76, flexShrink: 0 }}
          SelectProps={{ MenuProps: { PaperProps: { sx: { maxHeight: 320 } } } }}
        >
          {Object.entries(SECTION_ICONS).map(([key, Icon]) => (
            <MenuItem key={key} value={key} aria-label={key}>
              <Icon fontSize="small" color="secondary" sx={{ display: 'block' }} />
            </MenuItem>
          ))}
        </TextField>
        <TextField
          size="small"
          label="Section name"
          autoFocus
          fullWidth
          value={values.title}
          onChange={(e) => setValues({ ...values, title: e.target.value })}
          error={titleError}
          helperText={titleError ? 'Name is required' : undefined}
        />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
        <Button size="small" onClick={onCancel}>
          Cancel
        </Button>
        <Button size="small" type="submit" color="secondary">
          {submitLabel}
        </Button>
      </Box>
    </Box>
  );
};

export default SectionForm;
